import React, { useContext } from 'react'
import { ChangePresentContext, PostEventAnalysisContext } from '../SingleEvent'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { themes } from './themeList'

export { themes }

const PEAThemes = () => {
  const { postEventAnalysis, setPostEventAnalysis } = useContext(
    PostEventAnalysisContext
  )
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <>
      {themes.map((theme) => (
        <Grid container spacing={2} key={theme.dbName}>
          <Grid item xs={12} lg={2}>
            <Typography variant="title2" fontSize="1rem">
              {theme.title}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={5}>
            <TextField
              size="small"
              multiline
              fullWidth
              label="Analysis"
              value={postEventAnalysis?.[theme.dbName]?.analysis || ''}
              onChange={(e) => {
                !changesPresent && setChangesPresent(true)
                setPostEventAnalysis((prev) => ({
                  ...prev,
                  [theme.dbName]: {
                    ...prev?.[theme.dbName],
                    analysis: e.target.value,
                  },
                }))
              }}
            />
          </Grid>
          <Grid item xs={12} lg={5}>
            <TextField
              size="small"
              multiline
              fullWidth
              label="Recommendations"
              value={postEventAnalysis?.[theme.dbName]?.recommendations || ''}
              onChange={(e) => {
                !changesPresent && setChangesPresent(true)
                setPostEventAnalysis((prev) => ({
                  ...prev,
                  [theme.dbName]: {
                    ...prev?.[theme.dbName],
                    recommendations: e.target.value,
                  },
                }))
              }}
            />
          </Grid>
        </Grid>
      ))}
    </>
  )
}

export default React.memo(PEAThemes)
